import { render, staticRenderFns } from "./table-view-footer-goal-setting.component.vue?vue&type=template&id=3a1998b4&scoped=true"
import script from "./table-view-footer-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./table-view-footer-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./table-view-footer-goal-setting.component.vue?vue&type=style&index=0&id=3a1998b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1998b4",
  null
  
)

export default component.exports